import React, { useEffect, useState, useRef } from "react";
import axios from "axios";
import { useNavigate } from "react-router-dom";
import "./homeSlider.css";

import slider1 from "../../assets/image/imageslider1.jpg";
import slider2 from "../../assets/image/imageslider2.jpg";
import slider3 from "../../assets/image/imageslider3.jpg";
import slider4 from "../../assets/image/imageslider4.jpg";
import slider5 from "../../assets/image/imageslider5.jpg";
import slider6 from "../../assets/image/imageslider6.jpg";

const BASE_URL = "https://dashboard.jyotirvani.com";
const images2 = [slider1, slider2, slider3, slider4, slider5, slider6];
const categoryList = ["Gemstone", "Rudraksha", "Crystal Bracelet"];

function HomeSlider() {
  const navigate = useNavigate();
  const [current2, setCurrent2] = useState(0);
  const [products, setProducts] = useState([]);
  const [hoverStates, setHoverStates] = useState({});
  const scrollRefs = useRef({});
  const autoplayIntervals = useRef({});

  // Auto-switching banner
  useEffect(() => {
    const timeout = setTimeout(() => {
      setCurrent2((prev) => (prev + 1) % images2.length);
    }, 3000);
    return () => clearTimeout(timeout);
  }, [current2]);

  // Fetch product list
  useEffect(() => {
    axios
      .get(`${BASE_URL}/api/fetchproduct`)
      .then((res) => {
        const imagePath = `${BASE_URL}/uploads/productImage/`;
        const allProducts = res.data.data.map((p) => ({
          ...p,
          image: imagePath + p.image,
          category: p.category ? p.category.toLowerCase() : "",
        }));
        setProducts(allProducts);
      })
      .catch(() => {
        setProducts([]);
      });
  }, []);

  // Autoplay sliders
  useEffect(() => {
    categoryList.forEach((category) => {
      autoplayIntervals.current[category] = setInterval(() => {
        const ref = scrollRefs.current[category];
        if (ref && !hoverStates[category]) {
          const maxScroll = ref.scrollWidth - ref.clientWidth;
          if (ref.scrollLeft >= maxScroll - 5) {
            ref.scrollTo({ left: 0, behavior: "smooth" });
          } else {
            ref.scrollBy({ left: 200, behavior: "smooth" });
          }
        }
      }, 3000);
    });

    return () => {
      categoryList.forEach((category) => {
        clearInterval(autoplayIntervals.current[category]);
      });
    };
  }, [hoverStates]);

  const handleHover = (category, hovering) => {
    setHoverStates((prev) => ({ ...prev, [category]: hovering }));
  };

  const vedio = [
    {
      fullName: "Acharya Gopal Krishna",
      initials: "AK",
      date: "23 November 2024",
      video: "https://youtu.be/J0HHaHDlONk",
    },
    {
      fullName: "Acharya Gopal Krishna",
      initials: "AK",
      date: "13 December 2024",
      video: "https://youtu.be/qBZTnW9eS68",
    },
    {
      fullName: "Acharya Gopal Krishna",
      initials: "AK",
      date: "22 October 2024",
      video: "https://youtu.be/amSIhfv0Sco",
    },
    {
      fullName: "Acharya Gopal Krishna",
      initials: "AK",
      date: "22 October 2024",
      video: "https://youtu.be/uR-w8RUbXlo",
    },
  ];

  return (
    <div className="home-slider-wrapper">
      {/* Banner Slider */}
      {/* <div className="ra-main-slider">
        <div className="container">
          <div className="ra-home-part1-img">
            <div className="ra-home-image-slider">
              {images2.map((src, i) => (
                <div
                  key={i}
                  className="ra-home-image-slides"
                  style={{ display: i === current2 ? "block" : "none" }}
                >
                  <img src={src} alt={`Slide ${i + 1}`} />
                </div>
              ))}
              <div className="ra-home-image-dot">
                {images2.map((_, i) => (
                  <span
                    key={i}
                    className={`dot ${i === current2 ? "active" : ""}`}
                  ></span>
                ))}
              </div>
            </div>
          </div>
        </div>
      </div> */}

      {/* Video Carousel */}
      <div className="ra-home-vedio-section">
        <div className="container">
          <h2 className="ra-home-vedio-title">
            Astrologer's <span>Video</span>
          </h2>
          <p className="ra-home-vedio-subtitle">
            See What Our Astrologer Are Saying: Real Experiences!
          </p>
          <div
            className="ra-home-vedio-carousel"
            ref={(el) => (scrollRefs.current["video"] = el)}
          >
            {vedio.map((t, i) => (
              <div className="ra-home-vedio-card" key={i}>
                <div className="ra-home-vedio-video-wrapper">
                  <iframe
                    width="100%"
                    height="182"
                    src={`https://www.youtube.com/embed/${t.video.split("youtu.be/")[1]}`}
                    title={t.fullName}
                    frameBorder="0"
                    allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
                    allowFullScreen
                  ></iframe>
                </div>
                <div className="ra-home-vedio-user-details">
                  <div className="initials">{t.initials}</div>
                  <div>
                    <p className="full-name">{t.fullName}</p>
                    <p className="date">{t.date}</p>
                  </div>
                </div>
              </div>
            ))}
          </div>
        </div>
      </div>

      {/* Product Sliders by Category */}
      {categoryList.map((cat) => {
  const filtered = products.filter(
    (p) => p.category === cat.toLowerCase()
  );
  return (
    <div key={cat} className="ra-home-product-strip-section">
      <div className="container">
        <h2 className="ra-home-product-strip-title">{cat} Products</h2>
        <div
          className="ra-home-product-strip"
          ref={(el) => (scrollRefs.current[cat] = el)}
          onMouseEnter={() => handleHover(cat, true)}
          onMouseLeave={() => handleHover(cat, false)}
        >
         {filtered.map((product) => (
  <div
    key={product.id}
    className="ra-home-product-strip-item"
    style={{ cursor: "pointer" }}
    onClick={() => {
      if (product.id) {
        navigate(`/product/${product.id}`);
      } else {
        console.warn("No ID for product:", product);
      }
    }}
  >
    <img src={product.image} alt={product.title || product.name} />

    {/* <div className="ra-home-product-overlay">
      <p>{product.title || product.name}</p>
      <span>View Product</span>
    </div> */}
  </div>
))}
        </div>
      </div>
    </div>
  );
})}
    </div>
  );
}

export default HomeSlider;